import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Sounds } from '../../components/Sounds';

let soundsContainerRoot = null;

export const displayMediaCenterSoundIcon = (media: any): void => {
    const soundsContainer = document.querySelector('.audio-wrapper');
    const hideClass = 'is-hidden';

    if (soundsContainer) {
        const filterMediaByType = (mediaSets: any, type: string): any[] => mediaSets
            .filter(mediaSet => mediaSet.name === type)
            .reduce((result, mediaSet) => {
                result.push(...mediaSet.images);
                return result;
            }, []);

        const sounds = filterMediaByType(media, 'Sound');
        if (!soundsContainerRoot) {
            soundsContainerRoot = createRoot(soundsContainer);
        }

        const snd = filterMediaByType(media, 'SND');
        const pimsSounds = sounds.concat(snd);

        soundsContainerRoot.render(<Sounds sounds={pimsSounds} />);

        const soundsIconContainer = document.querySelector('[data-audio-dialog-trigger="mediacenter-sounds-dialog"]');
        if (soundsIconContainer) {
            if (sounds.length || pimsSounds.length) {
                soundsIconContainer.classList.remove(hideClass);
            } else {
                soundsIconContainer.classList.add(hideClass);
            }
        }
    }
}
